import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const radioOptionClassName = css({
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  padding: `${Spacing.XL}px 0`,
  '&:first-of-type': {
    paddingTop: 0,
  },
  '&:last-of-type': {
    paddingBottom: 0,
  },
  [SMALL_DEVICE_MQ]: {
    padding: Spacing.LG,
    '&:first-of-type': {
      paddingTop: Spacing.LG,
    },
    '&:last-of-type': {
      paddingBottom: Spacing.LG,
    },
    transition: '0.2s',
    '&:hover': {
      background: '#FBFBFB',
      input: {
        borderColor: Colors.Secondary,
      },
    },
  },
});

export const labelClassName = css({
  marginRight: Spacing.MD,
});

export const titleClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.SEMI_BOLD,
});

export const subtitleClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.NORMAL,
  marginTop: Spacing['1XS'],
  [SMALL_DEVICE_MQ]: {
    fontSize: FontSize.COMPACT,
  },
});

export const radioClassName = css({
  marginLeft: 'auto',
});

export const inputClassName = css({
  appearance: 'none',
  WebkitAppearance: 'none',
  background: Colors.White,
  border: `1px solid ${Colors.LightGray}`,
  borderRadius: '50%',
  boxSizing: 'border-box',
  cursor: 'pointer',
  display: 'flex',
  flex: '0 0 auto',
  height: 20,
  margin: 0,
  outline: 'none',
  overflow: 'hidden',
  resize: 'none',
  transition: '0.2s',
  width: 20,
});

export const activeRadioClassName = css({
  border: `6px solid ${Colors.Primary} !important`,
});
